import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from 'common';
import { SharedModule } from '../shared/shared.module';
import { OidcModule } from './oidc/oidc.module';
import { UserPasswordChangeFormComponent } from './user-password-change-form/user-password-change-form.component';
import { UserPasswordResetRoutingModule } from './user-password-reset/user-password-reset-routing.module';
import { UserRoutingModule } from './user-routing.module';
import { UserSignOutModule } from './user-sign-out/user-sign-out.module';
import { UserSignUpRoutingModule } from './user-sign-up/user-sign-up-routing.module';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    UserSignOutModule,
    UserRoutingModule,
    UserSignUpRoutingModule,
    UserPasswordResetRoutingModule,
    OidcModule
  ],
  exports: [
    UserSignOutModule,
    OidcModule
  ],
  declarations: [
    UserPasswordChangeFormComponent
  ]
})
export class UserModule { }

